module.exports = __webpack_public_path__ + "img/hand-love.84b570d5.svg";